import { render, staticRenderFns } from "./jianchahenjiDialog.vue?vue&type=template&id=064becda&"
import script from "./jianchahenjiDialog.vue?vue&type=script&lang=ts&"
export * from "./jianchahenjiDialog.vue?vue&type=script&lang=ts&"
import style0 from "./jianchahenjiDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports